import { CanDeactivateFn } from '@angular/router';
import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  UrlTree,
  CanDeactivate,
} from '@angular/router';
import { Observable } from 'rxjs';
import { MatDialog } from '@angular/material/dialog';
import { ConfirmInvoiceDeleteComponent } from '../confirm-delete-dialog/confirm-delete-dialog.component';

export const canDeactivateGuard: CanDeactivateFn<unknown> = (
  component,
  currentRoute,
  currentState,
  nextState,
) => {
  return true;
};

export interface CanComponentDeactivate {
  canDeactivate: () => Observable<boolean> | Promise<boolean> | boolean;
}

@Injectable({
  providedIn: 'root',
})
export class CanDeactivateGuard implements CanDeactivate<CanComponentDeactivate> {
  constructor(private dialog: MatDialog) {}

  canDeactivate(
    component: CanComponentDeactivate,
    currentRoute: ActivatedRouteSnapshot,
    currentState: RouterStateSnapshot,
    nextState?: RouterStateSnapshot,
  ): Observable<boolean> | Promise<boolean> | boolean {
    // Check if component has canDeactivate method
    if (component.canDeactivate) {
      const result = component.canDeactivate();

      // If it's a boolean, return it
      if (typeof result === 'boolean') {
        if (result) return true;
        return this.openConfirmDialog();
      }

      // If it's a Promise or Observable
      return new Promise<boolean>((resolve) => {
        if (result instanceof Observable) {
          result.subscribe((canDeactivate) => {
            if (canDeactivate) {
              resolve(true);
            } else {
              this.openConfirmDialog().then((dialogResult) => {
                resolve(dialogResult);
              });
            }
          });
        } else if (result instanceof Promise) {
          result.then((canDeactivate) => {
            if (canDeactivate) {
              resolve(true);
            } else {
              this.openConfirmDialog().then((dialogResult) => {
                resolve(dialogResult);
              });
            }
          });
        }
      });
    }

    return true;
  }

  async openConfirmDialog(): Promise<boolean> {
    const dialogRef = this.dialog.open(ConfirmInvoiceDeleteComponent, {
      width: '400px',
      height: '250px',
      data: {
        title: 'Modifiche non salvate',
        message: 'Ci sono modifiche non salvate. Vuoi davvero uscire?',
        checkboxLabel: 'Confermo di voler scartare il documento e accetto',
      },
    });

    const result = await dialogRef.afterClosed().toPromise();

    // Convert undefined/falsy to boolean
    return !!result;
  }
}
